<template>
  <div>
    <m-tabbar></m-tabbar>
    <div class="manage-style">
      <div class="topForm">
        <a-form id="add" :form="form" ref="formbook" layout="inline">
          <a-form-item label="时间">
            <!-- <a-button>本周</a-button>
                        <a-button>本月</a-button>
            <a-button>三个月</a-button>-->
            <a-range-picker
              style="width:225px"
              :allowClear="false"
              :placeholder="['开始时间', '结束时间']"
              :disabled-date="disabledDate"
              :defaultValue="[
                moment(
                  moment()
                    .subtract(7, 'days')
                    .calendar()
                ),
                moment(moment().subtract(1, 'days')),
              ]"
              @change="onChangeTime"
            />
          </a-form-item>
        </a-form>
      </div>
      <div v-if="!noData" class="analysisOnly">
        <div class="firstUl">
          <ul class="oneUl">
            <div class="leftDiv">
              <li>
                <p>平均得分率</p>
                <div>{{ taskList.aveScore | parseFloat }}%</div>
              </li>
            </div>
            <div class="rightDiv">
              <ul class="twoUl">
                <li>
                  <p>布置作业次数</p>
                  <div>{{ taskList.allExercise | parseFloat }}次</div>
                </li>
                <li>
                  <p>布置题目数量</p>
                  <div>{{ taskList.allQuestion | parseFloat }}题</div>
                </li>
                <li style="border-right:none;">
                  <p>主观题数量</p>
                  <div>{{ taskList.subjectivecount | parseFloat }}题</div>
                </li>
              </ul>
              <ul class="threeUl">
                <li>
                  <p>完成率</p>
                  <div>{{ taskList.submitRate | parseFloat }}%</div>
                </li>
                <li>
                  <p>批改率</p>
                  <div>{{ taskList.correctRate | parseFloat }}%</div>
                </li>
                <li>
                  <p>完对率</p>
                  <div>{{ taskList.rightRate | parseFloat }}%</div>
                </li>
                <li style="border-right:none;">
                  <p>订正率</p>
                  <div>{{ taskList.revisionRate | parseFloat }}%</div>
                </li>
              </ul>
            </div>
          </ul>
          <ul class="twoUl">
            <li>
              <p>每天平均作业量</p>
              <div>{{ (taskList.allExercise / day) | parseNum }}份</div>
            </li>
            <li>
              <p>每天平均试题量</p>
              <div>{{ (taskList.allQuestion / day) | parseNum }}题</div>
            </li>
            <li style="border-right:none;">
              <p>每天平均作业用时</p>
              <div>{{ (taskList.allTime * 10) | ms2min }}</div>
            </li>
          </ul>
          <ul class="twoUl">
            <li>
              <p>在用班级</p>
              <div>{{ taskList.classnum }}个</div>
            </li>
            <li>
              <p>在用教师</p>
              <div>{{ taskList.teachernum }}人</div>
            </li>
            <li style="border-right:none;">
              <p>在用学生</p>
              <div>{{ taskList.studentnum }}人</div>
            </li>
          </ul>
        </div>
        <!-- <div class="secondUl">
                    <div class="scoreLeft">
                        <p class="fL">{{ form.subjectname }}完对率走势图</p>
                        <highcharts :options="achievement" ref="highcharts" style="clear:both;"></highcharts>
                    </div>
                    <div class="rankRight">
                    </div>
        </div>-->
      </div>
      <div v-if="noData" class="noData" style="margin-top:100px;">
        <p>
          <img src="../../assets/images/noData.png" alt />
        </p>
      </div>
      <!-- 刷新 -->
      <div v-if="loadingList" style="position:fixed;margin-left:40%;top:55%;z-index:99;">
        <a-spin size="large" />
      </div>
    </div>
  </div>
</template>

<script>
import mTabbar from '../../../src/components/headTable'
import moment from 'moment'
export default {
  data () {
    return {
      noData: false,
      loadingList: false,
      moment,
      form: {
        startTime: moment()
          .subtract(7, 'days')
          .format('YYYY-MM-DD'),
        endTime: moment()
          .subtract(1, 'days')
          .format('YYYY-MM-DD'),
      },
      day: '',
      taskList: [],
      pagination: {
        pageSize: 5,
      },
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    disabledDate (current) {
      return current && current > moment(new Date()).add(-1, 'days')
    },
    // 时间
    onChangeTime (date, dateString) {
      this.form.startTime = dateString[0]
      this.form.endTime = dateString[1]
      this.day =
        moment(this.form.endTime).diff(moment(this.form.startTime), 'days') +
        Number(1)
      this.getHome()
    },
    // 获取首页数据
    getHome () {
      this.$http
        .get('/v1/learnonly/aianalyse/master/index', {
          params: {
            orgid: this.$store.getters.orgid,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
          },
        })
        .then((res) => {
          console.log(res)
          if (res.data.code == 200) {
            this.taskList = res.data.data
          } else {
            this.taskList = []
          }
        })
    },
  },
  components: {
    mTabbar,
  },
  filters: {
    parseNum (num) {
      if (num == undefined) {
        return '0'
      } else {
        return Math.round(num)
      }
    },
    // 保留两位小数去0
    parseFloat (num) {
      if (num == undefined) {
        return '0'
      } else {
        var val = parseFloat(num).toFixed(2)
        return parseFloat(val)
      }
    },
    ms2min (ms) {
      if (ms) {
        var min = Math.floor((ms / 1000 / 60) << 0)
        var sec = Math.floor((ms / 1000) % 60)
        return min + '分' + sec + '秒'
      } else {
        return '/'
      }
    },
  },
  mounted () {
    // 两日期间隔天数
    this.day =
      moment(this.form.endTime).diff(moment(this.form.startTime), 'days') +
      Number(1)
    this.getHome()
    // console.log(this.day)
    // 本月多少天
    // const startDate = moment().daysInMonth()
    // console.log(startDate)
  },
}
</script>

<style lang="scss">
@import '~@/assets/css/theme.scss';
</style>

<style scoped>
/* @import url('https://m1.bdp.cn/static/pkg/shareApp-bundle_74a0ab6.css'); */
/deep/ p {
  margin: 0;
  padding: 0;
}
.topForm {
  background: #fff;
  padding: 20px 0 0 0;
  border-bottom: 10px solid #eee;
  box-shadow: rgba(0, 0, 0, 0.25) 1px 1px 5px;
}
/deep/ .ant-form-inline .ant-form-item {
  display: inline-block;
  margin: 0 16px 20px 10px;
}
/* 1 */
.firstUl {
  background: #19192c;
  color: #fff;
  padding: 15px 15px 0 15px;
  min-height: 550px;
}
.firstUl ul li {
  float: left;
  background: #24263e;
  border-right: 10px solid #19192c;
  height: 120px;
  text-align: center;
  margin-bottom: 10px;
}
.firstUl ul li p {
  color: rgba(255, 255, 255, 0.7);
  padding-top: 30px;
}
.firstUl ul li div {
  font-size: 26px;
}
.firstUl .oneUl {
  display: flex;
}
.firstUl .oneUl .leftDiv {
  flex: 1;
  height: 250px;
}
.firstUl .oneUl .leftDiv li {
  height: 250px;
  width: 100%;
  padding: 60px 0;
}
.firstUl .oneUl .rightDiv {
  flex: 3;
}
.firstUl .twoUl li {
  width: 33.33%;
}
.firstUl .threeUl li {
  width: 25%;
}
/* 2 */
.secondUl {
  background: #19192c;
  color: #fff;
  padding: 10px 15px 0 15px;
  overflow: hidden;
  border-bottom: 10px solid #19192c;
}
.secondUl .scoreLeft {
  float: left;
  width: 50%;
  background: #24263e;
  border-right: 10px solid #19192c;
  height: 480px;
}
.secondUl .scoreLeft .fL {
  color: rgba(255, 255, 255, 0.7);
  padding: 20px;
  float: left;
}
.secondUl .scoreLeft .fR {
  color: rgba(255, 255, 255, 0.7);
  padding: 20px 20px 0;
  float: right;
  font-size: 16px;
  cursor: pointer;
}
.secondUl .rankRight {
  float: left;
  width: 50%;
  background: #24263e;
  height: 480px;
}
/deep/.analysisOnly .highcharts-grid-line {
  fill: none;
  stroke: rgba(255, 255, 255, 0.06);
}
</style>
